import { gql } from '@apollo/client';

export const GET_COMPANY_BY_ID = gql`
  query getCompanyById($companyId: String!) {
    getCompanyById(companyId: $companyId) {
      id
      name
      startBusinessHour
      endBusinessHour
      timeZone
    }
  }
`;
